import {SimulationsLayout} from "@/components/layouts/page/SimulationsLayout";

import {useEffect} from "react";

import {useLevelOrder} from "@hooks/LevelOrder";
import {
  clearOptions,
  getProductLine,
} from "@redux/slices/productSlices/optionsSlice";
import {
  clearTable,
  getAllProducts,
} from "@redux/slices/productSlices/tableSlice";
import {BorderArticle} from "@ui/general/BorderArticle";
import {Spinner} from "@ui/general/Spinner";
import {WarningData} from "@ui/general/WarningData";
import {useDispatch, useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const ProductPage = () => {
  const {productLevels} = useLevelOrder();
  const dispatch = useDispatch();

  const statusProducts = useSelector((state) => state.product.table.status);
  const statusLine = useSelector((state) => state.product.options.status);

  const {productLine} = useSelector((state) => state.product.options);
  const {data: products} = useSelector((state) => state.product.table);
  const {role, product_line} = useSelector((state) => state.common.candidate);

  const groupedProducts =
    role === "Admin" && products && productLine
      ? productLine.reduce((groups, line) => {
          const lineProducts = products.filter(
            (product) => product.product_line === line.name,
          );

          if (lineProducts.length > 0) {
            groups.push({
              id: line.id,
              name: line.name,
              products: lineProducts,
            });
          }

          return groups;
        }, [])
      : [];

  const allProducts = groupedProducts.sort((a, b) =>
    a.name.localeCompare(b.name),
  );

  useEffect(() => {
    if (role === "Admin") {
      dispatch(getProductLine());
    }

    dispatch(getAllProducts());

    return () => {
      dispatch(clearOptions());
      dispatch(clearTable());
    };
  }, [dispatch, role]);

  return (
    <div className={"container-big"}>
      <div className={styles.product}>
        {statusProducts === "loading" || statusLine === "loading" ? (
          <Spinner
            width={80}
            height={80}
          />
        ) : statusProducts === "error" || statusLine === "error" ? (
          <div className={styles.productEmpty}>
            <BorderArticle>
              <WarningData type={"error"} />
            </BorderArticle>
          </div>
        ) : (
            role === "Admin"
              ? allProducts.length === 0
              : !products || products.length === 0
          ) ? (
          <div className={styles.productEmpty}>
            <BorderArticle>
              <WarningData type={"empty"} />
            </BorderArticle>
          </div>
        ) : (
          <ul>
            {role === "Admin" ? (
              allProducts.map((item) => (
                <li key={item.id}>
                  <SimulationsLayout
                    title={item.name}
                    cards={item.products}
                    levelList={productLevels}
                  />
                </li>
              ))
            ) : (
              <li key={product_line}>
                <SimulationsLayout
                  title={product_line}
                  cards={products}
                  levelList={productLevels}
                />
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};
